import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ShareTrigger = styled(Icon)<{fontSize?: number}>`
  margin-left: ${globals.spu};
  font-size: ${p =>
    p.fontSize ? `${p.fontSize}px` : `calc(${globals.fontSizeStandard} * 1.5)`};
  cursor: pointer;
  &:hover {
    color: ${globals.TEAL_600};
  }
`;

export const ShareModal = styled(Modal)`
  position: relative;
  max-width: 600px;
`;

export const ShareModalContent = styled(Modal.Content)``;

export const ShareModalHeader = styled(Modal.Header)`
  font-size: calc(${globals.fontSizeStandard} * 1.5);
  margin-bottom: calc(${globals.spu} * 3);
`;

export const ShareModalClose = styled(Icon)`
  font-size: calc(${globals.fontSizeStandard} * 2);
  cursor: pointer;
  position: absolute;
  top: calc(${globals.spu} * 2);
  right: calc(${globals.spu} * 2);
  color: ${globals.gray500};
  &:hover {
    color: ${globals.gray800};
  }
`;
